import { cva, type VariantProps } from 'class-variance-authority';
import { Slot } from 'radix-ui';
import * as React from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

export const badgeVariants = cva(
  'group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring-base-default focus-visible:ring-[3px] focus-visible:ring-ring-base-default/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-border-danger-default aria-invalid:ring-border-danger-default/20 [&>svg]:pointer-events-none [&>svg]:size-3!',
  {
    variants: {
      variant: {
        default:
          'bg-surface-primary-default stext-contrast-default [a]:hover:opacity-80',
        secondary:
          'bg-surface-secondary-default stext-contrast-default [a]:hover:opacity-80',
        destructive:
          'bg-surface-danger-default stext-contrast-default [a]:hover:opacity-80',
        outline:
          'border-border-base-default bg-surface-base-default stext-base-default [a]:hover:opacity-80',
        subtle:
          'bg-surface-primary-subtle-default stext-primary-default [a]:hover:bg-surface-primary-subtle-hover',
        ghost: 'hover:bg-surface-muted-default hover:stext-muted-default',
        link: 'stext-link-default underline-offset-4 hover:underline',
      },
      shape: {
        default: 'rounded-4xl',
        square: 'rounded-md',
      },
    },
    defaultVariants: {
      variant: 'default',
      shape: 'default',
    },
  },
);

export function Badge({
  className,
  variant = 'default',
  shape = 'default',
  asChild = false,
  ...props
}: React.ComponentProps<'span'> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : 'span';

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      data-shape={shape}
      className={cn(
        'revers-badge',
        badgeVariants({ variant, shape }),
        className,
      )}
      {...props}
    />
  );
}
